import type { TFunction } from "i18next";

import { NO_VALUE_DISPLAY } from "../../constants";
import { RideStatusEnum } from "../../enums";

/** Label for already-existing course schedule slots in produce preview / metrics drawer. */
export const resolveCourseScheduleExistingStatusLabel = ({
  t,
  existingRideId,
  forNewSchedule = false,
}: {
  t: TFunction;
  existingRideId?: number;
  /** Kept for callers; status is rendered after #rideId via resolveCourseScheduleExistingRideStatusText. */
  existingRideStatus?: RideStatusEnum;
  /** When true and no existing ride — return "new" label instead of empty. */
  forNewSchedule?: boolean;
}): string => {
  if (!existingRideId) {
    return forNewSchedule
      ? t("rideProduction.courseScheduleNew")
      : NO_VALUE_DISPLAY;
  }

  // Ride status (e.g. New / Canceled) is shown after the ride id, not in this label
  return t("rideProduction.courseScheduleAlreadyCreated");
};

/** Translated existing-ride status for display after #rideId, e.g. "New". */
export const resolveCourseScheduleExistingRideStatusText = ({
  t,
  existingRideStatus,
}: {
  t: TFunction;
  existingRideStatus?: RideStatusEnum;
}): string | undefined => {
  if (!existingRideStatus) {
    return undefined;
  }

  return t(`selectListLabel.${existingRideStatus}`);
};
